export default __webpack_public_path__ + "static/media/Gloves of the Darkwretch.d30beb29.jpg";